import styled from 'styled-components';

export const FieldError = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-family: var(--set-page-base-font-family);
  line-height: 1.3;
  color: #e45c52;
`;
